import { render, staticRenderFns } from "./AgeGatem.vue?vue&type=template&id=d3f93560&scoped=true&"
import script from "./AgeGatem.vue?vue&type=script&lang=js&"
export * from "./AgeGatem.vue?vue&type=script&lang=js&"
import style0 from "./AgeGatem.vue?vue&type=style&index=0&id=d3f93560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f93560",
  null
  
)

export default component.exports